<template>
  <div
    class="md-content"
    :class="[contentClass, inContainer ? 'max-w-screen-xl mx-auto px-4' : '']"
    v-html="md.render(component.content)"
  />
</template>

<script setup lang="ts">
import type { StrapiProductContent } from '~/apollo/types/types';

const md = useMarkdownIt();

withDefaults(
  defineProps<{
    component: StrapiProductContent;
    contentClass?: string;
    /** When true (e.g. landing), add max-w mx-auto px-4. When false (e.g. news/blog), parent already provides container. */
    inContainer?: boolean;
  }>(),
  {
    contentClass: '',
    inContainer: false,
  },
);
</script>

<style>
.md-content {
  img {
    max-width: 100%;
  }

  p:not(:last-child) {
    margin-bottom: 1rem;
  }

  h2 {
    margin: 2rem 0;
    text-transform: uppercase;
  }

  h3 {
    margin: 0.5rem 0;
  }

  ul li {
    list-style-type: none;
    padding-left: 1.5rem;
    margin-bottom: 0.5rem;
    text-indent: -0.75rem;

    @media (width >= 768px) {
      padding-left: 2rem;
      text-indent: -1rem;
    }

    strong,
    b {
      display: contents;
    }
  }

  ul li::before {
    /* Unicode bullet ⬤ */
    content: '\2B24';
    font-size: 0.5em;
    display: inline-block;
    color: var(--color-brand);
    margin-right: 0.75rem;
    position: relative;
    bottom: 0.2rem;

    @media (width >= 768px) {
      margin-right: 1rem;
    }
  }

  blockquote {
    border-left: 3px solid var(--color-brand);
    padding-left: 1rem;

    p {
      font-style: italic;
      font-size: 1.2rem;
      font-weight: bolder;
    }

    p::before {
      content: '„';
    }

    p::after {
      content: '"';
    }
  }
}
</style>
